import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../api-client.config';

interface QuestionLiveStatusResponse {
  questionId: string;
  isLive: boolean;
  isManualScoring: boolean;
}

export const getQuestionLiveStatus = async (
  questionId: string
): Promise<QuestionLiveStatusResponse> => {
  const response = await (apiClient as any).get(
    `/api/admin/live-scoring/question/${questionId}/status`
  );
  return response as QuestionLiveStatusResponse;
};

export const useGetQuestionLiveStatusQuery = (questionId: string | null) => {
  return useQuery({
    queryKey: ['live-scoring', 'question', questionId, 'status'],
    queryFn: () => getQuestionLiveStatus(questionId!),
    enabled: !!questionId,
    refetchInterval: 5000, // Refetch every 5 seconds
  });
};
